import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/HomeView.vue') // Ensure this file exists
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;

